module.exports = __webpack_public_path__ + "img/aParty_121223_B.c440dbf0.jpg";